import { groupItemsDeep } from '@/utils/layers/groupUtils';
// import { GroupType } from '@/typings/customilyElements/elementsGroup';

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('SpotifyService', spotifyService);

    const SCANNABLE_URL = 'https://scannables.scdn.co/uri/plain/png/FFFFFF/black/640/';

    function spotifyService(SpotifyAPIService, DynamicVectorService, $mdDialog, $rootScope) {
        function fetchTrack(textTyped) {
            return SpotifyAPIService.fetchTrack(textTyped, $rootScope.user.Username)
                .then((response) => {
                    if (response && response.tracks) {
                        return response.tracks.items.slice(0, 5).map((item) => ({
                            album: item.album.name,
                            image: item.album.images[0]?.url || '', // Use optional chaining to prevent errors
                            artist: item.artists[0]?.name || 'Unknown Artist',
                            name: item.name,
                            scanableImg: SCANNABLE_URL + item.uri,
                            link: item.external_urls?.spotify || ''
                        }));
                    } else {
                        throw new Error(response.error.message);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching track:', error);
                    $mdDialog.show(
                        $mdDialog
                            .alert()
                            .clickOutsideToClose(true)
                            .title('We got an error from Spotify:')
                            .textContent(error.message || error.data)
                            .ok('Ok')
                    );
                });
        }

        async function addSpotifyPlayer($scope, canvas, canvasWidth, canvasHeight) {
            const spotifyElementsGroup = [];
            const fontSizeBoxHeigthProportion = 1 / 59;
            $scope.addImagePlaceholder();
            const albumImage = canvas.getActiveObject();
            albumImage.top = (canvasHeight * 12) / 32;
            albumImage.name = 'Album Image';
            $scope.addImagePlaceholder(null, { height: 0.04 * canvasHeight });
            const songBarcode = canvas.getActiveObject();
            $scope.updateImageType('single color', songBarcode);
            songBarcode.top = (canvasHeight * 17.5) / 32;
            songBarcode.name = 'Song Barcode';
            const textHeight = 0.05 * canvasHeight;
            $scope.addText(false, undefined, {
                height: textHeight,
                top: (canvasHeight * 19) / 32,
                textAlign: 'left',
                name: 'Track Name'
            });
            const trackName = canvas.getActiveObject();
            const trackNamemaxSizePx = textHeight * fontSizeBoxHeigthProportion * 25;
            trackName.set('maxSizePx', trackNamemaxSizePx);
            //we use an outline to make it bold
            const outlineWidth = textHeight * fontSizeBoxHeigthProportion;
            trackName.metadata = JSON.stringify({
                spotifyPlayer: {
                    isTrackName: true
                }
            });
            trackName.set('outlineWidth', outlineWidth);
            $scope.addText(false, undefined, {
                height: textHeight,
                top: (canvasHeight * 20) / 32,
                textAlign: 'left',
                name: 'Artist Name'
            });
            const artistName = canvas.getActiveObject();
            const artistNamemaxSizePx = textHeight * fontSizeBoxHeigthProportion * 17;
            artistName.set('maxSizePx', artistNamemaxSizePx);
            artistName.metadata = JSON.stringify({
                spotifyPlayer: {
                    isArtistName: true
                }
            });
            $scope.addDynamicEPSPlaceholder();
            const playerBase = canvas.getActiveObject();
            playerBase.top = (canvasHeight * 23) / 32;
            playerBase.name = 'Player controls';
            playerBase.set('height', 0.1 * canvasHeight);
            const playerVectorSVG = '/app/img/player-controls.svg';
            const playerVectorEPS = '/app/img/player-controls.eps';
            DynamicVectorService.addEPSGroup(playerBase, 1, playerVectorSVG, playerVectorEPS, false);
            DynamicVectorService.changeDynamicEPSPosition(playerBase, 1, canvas);

            spotifyElementsGroup.push(playerBase);
            spotifyElementsGroup.push(albumImage);
            spotifyElementsGroup.push(trackName);
            spotifyElementsGroup.push(artistName);
            spotifyElementsGroup.push(songBarcode);

            const playerGroup = await groupItemsDeep(spotifyElementsGroup, {
                canvas: canvas,
                saveHistory: false,
                spotifyPlayer: true,
                name: 'Spotify Player'
            });

            return playerGroup;
        }

        function spotifyGroupSelected() {
            return $scope.groupsSelected.length == 1 && $scope.groupsSelected[0].SpotifyPlayer;
        }

        return {
            fetchTrack,
            addSpotifyPlayer,
            spotifyGroupSelected
        };
    }
})();
